import type { WorkOrder } from '@ztechapps/common.contract'
import isEmpty from 'lodash/isEmpty'

export type WorkOrderRef = Pick<WorkOrder, '_id' | 'code' | 'status'> & {
  product?: { _id?: string }
}

/**
 * Computes the new full `relatedWorkOrders` array when the single production for one
 * line-item product is set or cleared.
 *
 * Preserves other products' associations and orphan entries (those whose product is
 * undefined or points at a different product); replaces only the given product's
 * association with the single selection. A null/empty selection clears it.
 */
export const mergeRelatedWorkOrdersForProduct = (
  existing: WorkOrderRef[],
  productId: string,
  selected: WorkOrderRef | null | undefined
): WorkOrderRef[] => {
  const preserved = (existing ?? []).filter((workOrder) => workOrder.product?._id !== productId)

  return isEmpty(selected) ? preserved : [...preserved, selected as WorkOrderRef]
}
